/* eslint-disable no-underscore-dangle */
import _ from 'underscore';
import { deburr, kebabCase, get } from 'lodash';
import { generateValueFor } from 'containers/PredictiveSearch/selectors';
import * as actions from 'actions/response';
import { TO_COMPLETE_INFO, TO_PAY_WAY } from 'containers/Headband/constants';
import { showHeadband } from 'action-creators/headband';
import { showModalPassword } from 'action-creators/forgot-password';
import { execSafePushSession } from 'utils/getStickySession';
import { getUserIsLoggendin } from 'containers/User/service';
import { GetEpgVersion, tvEverywhereEnable } from 'utils/getEpgParams';
import {
  defaultProductEncodesConfiguration,
  SUPPORTED_STREAM,
  GetRegion,
  PLAYER_SEGMENT,
  CODE_MENU,
} from 'constants.js';
import ClaroUrlBuilder from 'utils/ClaroUrlBuilder';
import { logOut } from 'context/services';
import Metrics from 'services/metrics';
import { store } from '../store';
import { isNewExperienceEnabledWNTranslations } from './isNewExperienceEnabled';
import { getUserId } from './User';
import { getTranslation } from './getTranslation';
import { getRegion } from './Region';
import { getClaroAdsKey } from './claroAds/getClaroAdskey';
import { getPaywayProfileService } from 'api/services/payway';
import { SET_USER_SUBSCRIPTIONS } from 'action-creators/user';
import { LOCAL_STORAGE_USER_TOKEN } from 'constants.js';

const UARegEx = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
const UAVendor = /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i;

class Utils {
  static saysWho() {
    const ua = navigator.userAgent;
    let tem;

    let M = ua.match(UAVendor) || [];

    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return ['IE ', tem[1] || ''];
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) {
        return tem
          .slice(1)
          .join(' ')
          .replace('OPR', 'Opera')
          .split(' ');
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    /* eslint no-cond-assign: 0 */
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M;
  }

  static getDeviceOS() {
    const userAgent = this.saysWho();
    return userAgent[0].toLowerCase().trim();
  }

  static createCookie(name, value, days) {
    let expires;
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toGMTString()}`;
    } else {
      expires = '';
    }
    document.cookie = `${name}=${value}${expires}'; path=/; Secure`;
  }

  static getCookie(name) {
    const re = new RegExp(`${name}=([^;]+)`);

    const value = re.exec(document.cookie);

    return value != null ? decodeURI(value[1]) : null;
  }

  static deleteCookie(name) {
    return this.createCookie(name, '', -1);
  }

  static setCookie(name, value, days) {
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = `; expires=${date.toGMTString()}`;
      document.cookie = `${name}=${value}${expires}; path=/; Secure`;
    } else {
      const expires = '';
      document.cookie = `${name}=${value}${expires}; path=/; Secure`;
    }
  }

  static getAbbreviation(country) {
    const abbreviations = {
      chile: 'CL',
      mexico: 'MX',
      colombia: 'CO',
      peru: 'PE',
      brasil: 'BR',
      argentina: 'AR',
      dominicana: 'DO',
      guatemala: 'GT',
      ecuador: 'EC',
      elsalvador: 'SV',
      paraguay: 'PY',
      nicaragua: 'NI',
      costarica: 'CR',
      uruguay: 'UY',
      honduras: 'HN',
      panama: 'PA',
      puertorico: 'PR',
    };
    return abbreviations[country] || null;
  }

  static returnAbbreviation(country) {
    const abbreviations = {
      argentina: 'arg',
      brasil: 'br',
      chile: 'ch',
      colombia: 'co',
      costarica: 'cr',
      dominicana: 'dom',
      ecuador: 'ec',
      guatemala: 'gt',
      honduras: 'hn',
      mexico: 'mx',
      nicaragua: 'ni',
      panama: 'pa',
      peru: 'pe',
      paraguay: 'py',
      elsalvador: 'sv',
      uruguay: 'uy',
      puertorico: 'pr',
    };

    return abbreviations[country] || null;
  }

  static getBackgrounds(assets, common, prefix) {
    const screenResolution = {
      large: 'lg',
      small: 'sm',
      extra_large: 'xl',
      extra_small: 'xs',
    };

    const background = {
      backgroundLg: null,
      backgroundSm: null,
      backgroundXl: null,
      backgroundXs: null,
    };

    const lg = `${common}${screenResolution.large}_${prefix}`;
    const sm = `${common}${screenResolution.small}_${prefix}`;
    const xl = `${common}${screenResolution.extra_large}_${prefix}`;
    const xs = `${common}${screenResolution.extra_small}_${prefix}`;

    const lgDefault = '/webclient/sk_core/images/bg-registro-lg-peru.jpg';
    const smDefault = '/webclient/sk_core/images/bg-registro-lg-peru_blur.jpg';

    background.backgroundLg = assets[lg] ? assets[lg] : lgDefault;
    background.backgroundSm = assets[sm] ? assets[sm] : smDefault;
    background.backgroundXl = assets[xl] ? assets[xl] : lgDefault;
    background.backgroundXs = assets[xs] ? assets[xs] : smDefault;

    return background;
  }

  static isOnUrl(expression) {
    return window.location.pathname.indexOf(expression) !== -1;
  }

  static urlParamsToJson(string) {
    const newObj = {};
    let urlParams = string.split('?')[1];
    urlParams = urlParams.split('&').reduce((prev, curr, i, arr) => {
      const p = curr.split('=');
      prev[decodeURIComponent(p[0])] = decodeURIComponent(p[1]);
      return prev;
    }, {});

    for (const option in urlParams) {
      newObj[option] = urlParams[option];
    }
    return newObj;
  }

  static MobileCheck() {
    return UARegEx.test(navigator.userAgent);
  }

  static isAndroidDlaApk() {
    const ua = navigator.userAgent;
    return /androiddlaapk/i.test(ua) || /android/i.test(ua);
  }

  static isIosDlaApk() {
    const ua = navigator.userAgent;
    return (
      /iosdlaapk/i.test(ua) ||
      /iPod/i.test(ua) ||
      /iPhone/i.test(ua) ||
      /iPad/i.test(ua)
    );
  }

  static isAmino() {
    const ua = navigator.userAgent;
    return /amino/i.test(ua);
  }

  static isW8OldDlaApk() {
    const ua = navigator.userAgent;
    return /WOW64/i.test(ua) && /Windows NT/i.test(ua);
  }

  static encode_utf8(s) {
    try {
      return unescape(encodeURIComponent(s));
    } catch (ex) {
      return s;
    }
  }

  static decode_utf8(s) {
    try {
      return decodeURIComponent(escape(s));
    } catch (ex) {
      return s;
    }
  }

  /**
   * Bind it.
   * Use context of a React Class connected to store "user" property.
   *
   */
  static userStatusParse(user) {
    const userDataStatus = user.userType;

    const userStatusDraft = {
      ANONYMOUS: 'anonymous',
      SUSC: 'susc',
      NO_SUSC: 'no_susc',
    };

    return userStatusDraft[userDataStatus];
  }

  static buildRedirect(options) {
    let redirectUrl;
    const userType = this.__getUserType.bind(this)();
    const live_enabled = options?.content?.live_enabled || options?.content?.liveType;
    let { type } = options.content;
    const region = localStorage.getItem('loginInfo.region');
    const { title_uri } = options.content;
    const id = options.content.id || options.content.group_id;
    const formatTypes = options.content.format_types;
    const playerUrl = options.urlPlayer;
    let action;
    // TODO: make node dinamyc
    const node = 'homeuser';

    // First check live content
    if (Number(live_enabled) === 1) {
      type = 'live';
      if (formatTypes === 'ppe') type = 'group';
    }

    if (!type) {
      type = 'group';
    }

    // Chekc content type

    switch (type) {
      case 'app_behaviour': {
        const { app_behaviour } = options.content;

        const user_status = userType; // (typeof app_behaviour === 'string')&&(options.user_status.indexOf(userType)>-1);
        // Evaluate url to redirect
        if (app_behaviour.indexOf('http') !== -1) {
          action = { source: app_behaviour, type: 'open' };
          break;
        }
        if (typeof app_behaviour === 'string') {
          /**
           *
           * Redirect acorde con el documento; https://dlatvarg.atlassian.net/wiki/plugins/servlet/mobile#content/view/172557139
           * 03-11-16
           *
           */

          if (app_behaviour === 'register') {
            // Validate session
            if (userType !== 'anonymous') {
              // Validate susc
              const user = JSON.parse(
                window.localStorage.getItem('loginInfo.logged_user_data') ||
                  '{}',
              );
              // Validate does not have susc or pay method saved
              if (!user.hasUserSusc && !user.hasSavedPayway) {
                // Redirect to susc
                redirectUrl = `${region}/payment`;
              }
              // Anonymous user
            } else {
              redirectUrl = `${region}/landing`;
            }
            break;
          }
        }
        break;
      }
      case 'live':
      case 'L':
      case '0': {
        const userId = getUserId();
        let souurceULRLlive = '';
        if (options.content.begintime) {
          const startTime = new Date(options.content.begintime).getTime();
          const endTime = new Date(options.content.endtime).getTime();
          const actualTime = new Date().getTime();
          if (startTime <= actualTime && endTime >= actualTime) {
            // now
            const SO = this.getDeviceOS();

            const experiencia = isNewExperienceEnabledWNTranslations(
              GetRegion(),
            )
              ? '&guidechannel'
              : '';
            let browser;
            if (playerUrl[SO]) browser = playerUrl[SO];
            else browser = playerUrl.default;
            souurceULRLlive = ClaroUrlBuilder.player(id);
            if (this.MobileCheck()) {
              souurceULRLlive = `/${region}/devices?runplayerinapp&group_id=${id}&user_id=${userId}`;
            }
          } else {
            // past or future
            souurceULRLlive = `/${region}/event/${
              options.content.id
            }?&user_id=${userId}&groupId=${
              options.content.group_id
            }&startTime=${startTime}/`;
          }
        } else {
          const SO = this.getDeviceOS();
          const experiencia = isNewExperienceEnabledWNTranslations(GetRegion())
            ? '&guidechannel'
            : '';
          let browser;
          if (playerUrl[SO]) browser = playerUrl[SO];
          else browser = playerUrl.default;
          souurceULRLlive = ClaroUrlBuilder.player(id);
          if (this.MobileCheck()) {
            souurceULRLlive = `/${region}/devices?runplayerinapp&group_id=${id}&user_id=${userId}`;
          }
        }
        souurceULRLlive += '&hide_grid';
        action = {
          source: souurceULRLlive,
          type: 'location-tv',
          channel: options.content,
        };

        break;
      }
      case 'node':
        redirectUrl = `/${region}/${options.content.section}`;
        break;

      case 'special':
        // TODO: migrate special view
        action = {
          source: `https://${document.location.host}/${region}/${
            options.content.special
          }?especialesbts`,
          type: 'location',
        };
        break;

      case 'group':
      case 'P':
      case 'S':
        redirectUrl = `/${region}/vcard/${node}/${title_uri}/${id}`;

        break;

      case 'playAndGo':
        if (options.content.isFirst) {
          redirectUrl = undefined;
        } else {
          redirectUrl = `/${region}/${options.content.code}`;
        }

        break;

      default:
        redirectUrl = `/${region}/${node}`;
        break;
    }

    return { redirectUrl, action };
  }

  static __getUserType() {
    /**
     *
     * Use only when have heritage from buildRedirect
     *
     */
    const isBound = this.hasOwnProperty('options');
    if (isBound) {
      return this.options.userType;
    }
    let loggedInStore = localStorage.getItem('loginInfo.logged_user_data');
    let userType = 'anonymous';

    if (!loggedInStore) {
      return userType;
    }

    loggedInStore = JSON.parse(loggedInStore || '{}');
    userType =
      loggedInStore && loggedInStore.user_id
        ? loggedInStore.hasUserSusc || loggedInStore.hasSavedPayway
          ? 'susc'
          : 'no_susc'
        : 'anonymous';

    return userType;
  }

  static checkLogin(options, cb, navigate) {
    const self = this;
    const ipTelmexRedirect = localStorage.getItem('ipTelmexRedirect');
    const isclaroAdsActived = getClaroAdsKey(store.getState());
    const hasToStopAutologinIpelmex =
      (localStorage.getItem('logOutForce') === 'actived' &&
        !isclaroAdsActived) ||
      ipTelmexRedirect !== null;
    //This flow was written to stop infinite autologin telmex islogeddin v1 NOTE
    //after v2 islogeddin is not supported
    //if (hasToStopAutologinIpelmex) {
      //localStorage.removeItem('ipTelmexRedirect');
      //return cb({});
    //}

    // TODO: Please move this logic to a right service validator
    if (window.location.pathname.indexOf('/reset-password') > -1) {
      return this.__setNotLoggedUserData({}, cb);
    }

    const hasSession = localStorage.getItem('loginInfo.logged_user');

    if (
      window.location.pathname.indexOf('/forgottenPassword') > -1 &&
      hasSession === 'true' &&
      !sessionStorage.getItem('changePasswordModal')
    ) {
      logOut({all_session:false}).then(() => {
        localStorage.clear();
        window.location.reload();
        this.__setNotLoggedUserData({}, cb);
      });

      return;
    }

    const userLogged = result => {
      const { response } = result;
      if (response.is_user_logged_in == '1') {
        return this.__setLoggedUserData(response, cb);
      }
      return this.__setNotLoggedUserData(response, cb);
    };

    const getPaywayProfileSubscriptions = async userToken => {
      try {
        const { data: subscriptionsResp } = await getPaywayProfileService(
          userToken,
        );
        if (subscriptionsResp?.response?.subscriptions) {
          const subscriptionsMapped = subscriptionsResp?.response?.subscriptions.map(
            sub => sub?.provider,
          );
          store.dispatch({
            type: SET_USER_SUBSCRIPTIONS,
            payload: subscriptionsMapped,
          });

          return {
            subscriptions: subscriptionsMapped,
            paymentMethods: subscriptionsResp?.response?.paymentMethods,
          };
        }
        return { subscriptions: [], paymentMethods: [] };
      } catch (error) {
        console.log(error);
        return { subscriptions: [], paymentMethods: [] };
      }
    };

    const doUserLogin = () => {
      const claroLiteConfig = getClaroAdsKey(store.getState());
      getUserIsLoggendin({
        claroLiteConfig: claroLiteConfig,
      }).then(
        async result => {
          store.dispatch(actions.removeModal(''));

          if (result?.response?.lasttouch?.profile) {
            localStorage.setItem(
              'lasttouch.profile',
              result.response.lasttouch.profile,
            );
          }

          const isLoggedIn = get(result, 'response.is_user_logged_in', false);
          if (isLoggedIn == 1) {
            const counValidEmail = get(result, 'response.counterValidEmail', 0);
            let userMailValidation = {};
            try {
              userMailValidation =
                JSON.parse(window.metadata.user_mail_validation || '{}')?.[
                  GetRegion()
                ] ||
                JSON.parse(window.metadata.user_mail_validation || '{}')
                  ?.default;
            } catch {
              userMailValidation = {};
            }
            const isPayment =
              window.location.pathname.indexOf('payment') !== -1;
            const isValidEmail = get(result, 'response.validEmail', false);
            const { enable, limit } = userMailValidation;
            const pToken = sessionStorage.getItem('changePasswordModal');
            if (pToken) {
              store.dispatch(
                showModalPassword({
                  token: pToken,
                }),
              );
            }


            const renderHeadband = (message, action) => {
                 store.dispatch(
                   showHeadband({
                    message,
                    action
                   })
                 )
            }

            let subscriptions;
            let paymentMethods;
            const resultPayway = await getPaywayProfileSubscriptions(
              result?.response?.user_token,
            );
            subscriptions = resultPayway?.subscriptions;
            paymentMethods = resultPayway?.paymentMethods;
            if (!claroLiteConfig  && resultPayway?.subscriptions?.length === 0 && isValidEmail) {
              renderHeadband(TO_PAY_WAY, () => navigate(`/${GetRegion()}/planselect`));
            }


            if (
              !isValidEmail &&
              (!enable || (enable && counValidEmail < limit))
            ) {
              renderHeadband( TO_COMPLETE_INFO, () => navigate(`/${GetRegion()}/completeinfo?s=1`))
            }
            execSafePushSession(get(result, ['response'], {}))
              .then(resp => {
                if (resp.status !== 200) {
                  const msg = window.utils.getMeta.translations(
                    get(resp, 'errors.code', 'PGS-CHM-00001'),
                  );
                  const msgDefault = window.utils.getMeta.translations(
                    'PGS-CHM-00001',
                  );

                  store.dispatch(
                    actions.showModal({
                      modalType: 'RetryPushSession',
                      props: {
                        message: msg !== undefined ? msg : msgDefault,
                        home: !isPayment,
                        onRetry: () => window.location.reload(),
                      },
                    }),
                  );
                }
                return userLogged({
                  ...result,
                  response: {
                    ...result.response,
                    subscriptions,
                    paymentMethods,
                    paywayProfile: {
                      subscriptions,
                      paymentMethods,
                    },
                  },
                });
              })
              .catch(err => {
                const msg = window.utils.getMeta.translations(
                  get(err, 'errors.code', 'PGS-CHM-00001'),
                );
                const msgDefault = window.utils.getMeta.translations(
                  'PGS-CHM-00001',
                );
                store.dispatch(actions.removeModal(''));
                store.dispatch(
                  actions.showModal({
                    modalType: 'RetryPushSession',
                    props: {
                      message: msg !== undefined ? msg : msgDefault,
                      home: !isPayment,
                      onRetry: () => window.location.reload(),
                    },
                  }),
                );
                return userLogged(result);
              });
          } else {
            const acceptTerms = get(result, 'errors.code', false);
            const isIpTelmex =
              get(
                result,
                'response.userDetectWS.user_status.user_exists',
                false,
              ) ||
              get(result, 'data.userDetectWS.user_status.user_exists', false);
            if (acceptTerms === 'accept_terms' || isIpTelmex === 'N') {
              return this.__setNotLoggedUserData(result, cb);
            }
            return self.__setNotLoggedUserData({}, cb);
          }
        },
        err => this.__setNotLoggedUserData(err, cb),
      );
    };
    return doUserLogin();
  }

  static async __setNotLoggedUserData(responseInfo, cb) {
    const response = get(responseInfo, 'response.data', responseInfo);
    const userWS =
      get(response, ['response', 'userDetectWS'], false) ||
      get(response, ['data', 'userDetectWS'], false);
    const acceptTerms =
      get(response, ['completeError', 'errors', 'code'], '') ||
      get(response, ['errors', 'code'], '');
    const bePlayerIpTelmex = location.href.indexOf('iframe') !== -1;

    if (userWS && acceptTerms === 'accept_terms') {
      const type =
        get(response, ['completeError', 'errors', 'type'], '') ||
        get(response, ['errors', 'type'], '');
      Metrics.newEvent({
        event: 'Error',
        eventCategory: 'Errores',
        eventAction: 'Error',
        eventLabel: `Auto_Login_IpTelmex-(WEB)_API_${acceptTerms}-${
          type.type === 'internal' ? 'Int' : 'Ext'
        }`,
      });

      localStorage.setItem(
        'loginInfo.needsAcceptTerms',
        JSON.stringify(response),
      );
      localStorage.setItem('loginInfo.acceptedTerms', 0);
      localStorage.setItem('customEndPoint', userWS.url);

      if (Utils.isDeepLink(window.location.href)) {
        const ipTelmexPromotion = {};
        const ipTelmexDeepUrl = this.createDeepLinkToPlayer(window.location);
        ipTelmexPromotion.urlPromotion =
          ipTelmexDeepUrl.href || ipTelmexDeepUrl;
        ipTelmexPromotion.lit = true;
        localStorage.setItem(
          'ipTelmexPromotion',
          JSON.stringify(ipTelmexPromotion),
        );
      }

      if (response?.response?.acceptTerms === 0) {
        location.replace(`/${GetRegion()}/terms`);
      }
    } else if (
      !bePlayerIpTelmex &&
      (response?.response?.userDetectWS || response?.data?.userDetectWS) &&
      (!localStorage.getItem('gotToZendTelmex') ||
        Utils.isDeepLink(window.location.href))
    ) {
      if (Utils.isDeepLink(window.location.href)) {
        const ipTelmexPromotion = {};
        ipTelmexPromotion.urlPromotion = this.createDeepLinkToPlayer(
          window.location,
        );
        localStorage.setItem(
          'ipTelmexPromotion',
          JSON.stringify(ipTelmexPromotion),
        );
      }

      const userDetectData =
        response?.response?.userDetectWS || response?.data?.userDetectWS;
      if (userDetectData?.url && userDetectData?.ip) {
        let ipTelmexUser = {
          ip: userDetectData.ip,
          account: userDetectData?.account,
          url: userDetectData.url,
        };

        ipTelmexUser = JSON.stringify(ipTelmexUser);

        localStorage.setItem('loginIng.ip_telmex', ipTelmexUser);
        return this.__redirectUser(response, userDetectData, cb);
      }
    }
    // if(localStorage.getItem('gotToZendTelmex'))
    //   localStorage.removeItem('gotToZendTelmex');
    const isLogged = localStorage.getItem('loginInfo.logged_user');

    if (isLogged !== 'false') {
      localStorage.setItem('loginInfo.logged_user_data', '{}');
      localStorage.setItem(LOCAL_STORAGE_USER_TOKEN, '');
      localStorage.setItem('loginInfo.logged_user', false);
    }
    return cb({});
  }

  static isUser360() {
    const userData = localStorage.getItem('loginInfo.logged_user_data');
    const user = userData && JSON.parse(userData || '{}');
    return user.data360 || false;
  }

  static async __setLoggedUserData(response, cb, skipIpTelmex) {
    let isIpTelmex = false;
    if (!skipIpTelmex) {
      isIpTelmex = this.verifyIsIpTelmex(response, cb);
    }
    const data360 =
      response.socialNetworks &&
      response.socialNetworks.filter(
        network => network.redsocial === 'THREESIXTY',
      );

    let userData = {
      user_id: response.user_id,
      parent_id: response.parent_id,
      username: response.email,
      username1: response.username,
      firstname: response.firstname,
      lastname: response.lastname,
      subregion: response.subregion,
      hasSavedPayway: parseInt(response.hasSavedPayway, 10) === 1,
      hasUserSusc: parseInt(response.hasUserSusc, 10) === 1,
      gamification_id: response.gamification_id,
      subscriptions: response.subscriptions,
      data360: data360 && data360.length ? data360[0] : false,
      token: response.user_token,
      profile: {
        subscriptions: response.subscriptions,
        paymentMethods: response.paymentMethods,
      },
      superHighlight: response.superhighlight,
      email: response.email,
      validEmail: response.validEmail,
      isAdmin: response.admin,
      acceptTerms: response.accepted_terms,
      is_user_logged_in: response.is_user_logged_in,
      session_stringvalue: response.session_stringvalue,
      isKids: response.is_kids,
    };
    let params = {};
    if (tvEverywhereEnable()) {
      if (response.subregion) {
        params = { subregion: response.subregion };
      }
      const epgVersion = GetEpgVersion();
      if (epgVersion) {
        userData.epgVersion = epgVersion;
      }
    }
    const epgMenu = store.getState().epgMenu.epgMenu;
    if (
      _.isArray(epgMenu?.nodes) &&
      epgMenu?.nodes[0] &&
      epgMenu?.nodes[0]?.id
    ) {
      userData.nodeId = epgMenu?.nodes[0]?.id;
    }

    const lastTouch = localStorage.getItem('lasttouch');
    if (!lastTouch) {
      localStorage.setItem('lasttouch', response.lasttouch.seen);
    }
    const lastTouchProfile = localStorage.getItem('lasttouch.profile');
    if (!lastTouchProfile) {
      localStorage.setItem('lasttouch.profile', response.lasttouch.profile);
    }

    userData = JSON.stringify(userData);
    localStorage.setItem('loginInfo.logged_user', true);
    localStorage.setItem('loginInfo.logged_user_data', userData);
    localStorage.setItem(LOCAL_STORAGE_USER_TOKEN, response.user_token);
    localStorage.setItem('loginInfo.region', response.region);
    localStorage.setItem('loginInfo.userhash', response.session_userhash);
    localStorage.setItem('loginInfo.acceptedTerms', response.accepted_terms);
    if (response.paywayProfile) {
      localStorage.setItem(
        'loginInfo.profile',
        JSON.stringify(response.paywayProfile),
      );
    } else {
      localStorage.setItem('loginInfo.profile', JSON.stringify({}));
    }
    const ipTelmexRedirect = localStorage.getItem('ipTelmexRedirect');
    if (isIpTelmex && ipTelmexRedirect === null)
      this.redictFormIpTelmex(isIpTelmex);
    return cb(JSON.parse(userData || '{}'));
    // if (isLoggedYet != 'true') {
    //   return cb();
    // }
  }

  static openModalUpdateInfo() {
    const modal = {
      modalType: 'CompleteInfo',
    };
    store.dispatch(actions.showModal(modal));
  }

  static verifyIsIpTelmex(response, cb) {
    const userDetectWS =
      response.userDetectWS !== null
        ? response.userDetectWS
        : JSON.parse(localStorage.getItem('loginIng.ip_telmex') || '{}');

    if (userDetectWS) {
      localStorage.setItem('loginIng.ip_telmex', JSON.stringify(userDetectWS));
      if (userDetectWS.url)
        localStorage.setItem(
          'customEndPoint',
          userDetectWS.url.replace('http:', 'https:'),
        );
      if (parseInt(response.is_user_logged_in) === 1) {
        Metrics.newEvent({
          event: 'Login',
          eventCategory: 'landing',
          eventAction: 'inicia sesion',
          eventLabel: 'exitoso - autologin',
        });
        const activeSusc = get(userDetectWS, 'user_status.active_susc', false);
        if (activeSusc === 'N') {
          const userExist = get(userDetectWS, 'user_status.user_exists', false);
          // return this.redictFormIpTelmex(userExist);
          return userExist;
        }
      } else {
        return this.__setNotLoggedUserData(
          Object.assign({}, response, { userDetectWS }),
          cb,
        );
      }
    }
    return false;
  }

  static redictFormIpTelmex(userExist) {
    const utmParams = [
      'utm_campaign',
      'utm_content',
      'utm_medium',
      'utm_source',
    ];
    const searchParams = utmParams.reduce(
      (accum, current) =>
        accum || window.location.search.indexOf(current) !== -1,
      false,
    );
    if (searchParams)
      localStorage.setItem('ipTelmexAfterRegister', window.location.href);

    localStorage.setItem('ipTelmexRedirect', true);
    if (userExist === 'N') {
      window.location = `https://${
        window.location.host
      }/${GetRegion()}/userdetectwsregister`;
    }
    if (userExist === 'Y') {
      window.location = `https://${
        window.location.host
      }/${GetRegion()}/iptelmexactivate`;
    }
    return false;
  }

  static __redirectUser(result, userDetectData, cb) {
    const region = localStorage.getItem('loginInfo.region');

    const notLoggedUserFunction = () => {
      const activeSusc = get(userDetectData, 'user_status.active_susc', false);
      if (activeSusc === 'N') {
        localStorage.setItem('gotToZendTelmex', true);
        if (this.isDeepLink(window.location.href)) {
          let urlIpTelmex = JSON.parse(
            localStorage.getItem('ipTelmexPromotion') || '{}',
          );
          urlIpTelmex = urlIpTelmex || {};
          urlIpTelmex.lit = true;
          urlIpTelmex.urlInitSession = this.createDeepLinkToPlayer(
            window.location,
          );
          localStorage.setItem(
            'ipTelmexPromotion',
            JSON.stringify(urlIpTelmex),
          );
        }
        const userExist = get(userDetectData, 'user_status.user_exists', false);
        this.redictFormIpTelmex(userExist);
      }
    };
    const routes = {
      accept_terms: () => {
        const isUserLoggedIn = result?.response?.is_user_logged_in;

        if (isUserLoggedIn === '0') {
          localStorage.setItem('loginInfo.acceptedTerms', 0);
          localStorage.setItem('customEndPoint', userDetectData.url);
          if (cb) cb();
          return location.replace(`/${region}/terms`);
        }
      },

      usuario_no_logueado: notLoggedUserFunction,

      USR_USR_00001: notLoggedUserFunction,
    };

    const redirect = routes[(result?.errors?.code)];

    if (redirect) {
      return redirect();
    }
  }

  static getNewFilters(metadata) {
    if (!metadata || !metadata.byr_filterlist_configuration) return null;
    let filterId = JSON.parse(metadata.byr_filterlist_configuration || '{}');
    filterId = filterId[GetRegion()] || filterId.default;
    if (filterId && filterId.filterlist) filterId = filterId.filterlist;
    return filterId;
  }

  static buildFoxesNodes(node) {
    const type = 'playAndGo';
    const { childs } = node;
    this.foxNodes = {};
    this.getCarousel = (child, isFirst = false) => ({
      image_large: `nav_${child.code}${isFirst ? '_over' : ''}`,
      image_medium: `nav_${child.code}${isFirst ? '_over' : ''}`,
      image_small: `nav_${child.code}${isFirst ? '_over' : ''}`,
      code: child.code,
      type,
      isFirst,
    });

    this.mapper = childs => {
      childs.map(child => {
        const childs = child.childs;
        if (childs && Array.isArray(childs) && childs.length > 0) {
          this.mapper(childs);
        }

        this.parser(child);
        return child;
      });
    };

    this.parser = node => {
      const childs = node.childs;
      const code = node.code;

      this.foxNodes[code] = {};
      this.foxNodes[code].id = node.id;
      this.foxNodes[code].id_parent = node.id_parent;
      this.foxNodes[code].type = type;
      this.foxNodes[code].carosuel = [this.getCarousel(node, true)];

      if (childs && Array.isArray(childs) && childs.length > 0) {
        childs.map(child => {
          this.foxNodes[code].carosuel.push(this.getCarousel(child));
          return child;
        });
      }
    };

    if (childs && Array.isArray(childs) && childs.length > 0) {
      this.mapper(childs);
    }
    this.parser.bind(this)(node);

    return this.foxNodes;
  }

  static createId() {
    return parseInt(Date.now() + Math.random() * (80000 - 10000) + 10000);
  }

  static generateRandom(min, max) {
    return Math.floor(Math.random() * max) + min;
  }

  static generateRandomToString(length) {
    let random = '';
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let i = 0;
    for (i; i < length; i++) {
      random += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return random;
  }
  /**
   * should return true if listadoinfinito exists
   * @params{object} modules data
   * @returns {boolean}
   */

  static listInfiniteIsTrue(response) {
    if (!response) {
      return false;
    }

    if (response.modules && Object.keys(response.modules)) {
      const modules = response.modules;
      if (modules && modules.module && Array.isArray(modules.module)) {
        if (modules.module.length > 0) {
          const module = modules.module[0];
          if (module && module.components && Object.keys(module.components)) {
            const components = module.components;
            if (
              components &&
              components.component &&
              Array.isArray(components.component)
            ) {
              return true;
            }
          }
        }
      }
    }
  }

  static propertyExists(resource, key) {
    return !!resource[key];
  }

  static processSelected(plan) {
    return plan
      ? plan.oneofferdesc
      : $('input:checked')
          .parent()
          .text();
  }

  static processSubscription(source) {
    if (source !== 'CV_MENSUAL' && source !== 'CV_SEMANAL') {
      return `Suscripcion ${source}`;
    }
    if (source === 'CV_MENSUAL') {
      return 'Suscripcion Mensual';
    }
    return 'Suscripcion Semanal';
  }

  static isEmptyObject(obj) {
    for (const i in obj) {
      return false;
    }
    return true;
  }

  static getExternalProviderOffers(provider, paywayData) {
    const lowerProvider = provider.toLowerCase();
    return paywayData
      .filter(d => d.producttype.toLowerCase() === lowerProvider)
      .map(d => d.offer_id);
  }

  static getProviderByOffer_id(offer_id, transactionalConfiguration) {
    const region = localStorage.getItem('loginInfo.region');
    const meta = JSON.parse(transactionalConfiguration || '{}');
    const config = (meta && (meta[region] || meta.default)) || false;

    if (offer_id && config && config.suscription) {
      if (
        config.suscription.offers &&
        config.suscription.offers.find(offer => offer === offer_id)
      ) {
        return 'AMCO';
      }
      if (config.suscription.external_offers) {
        const offers = config.suscription.external_offers;
        for (const provider in offers) {
          if (offers[provider].find(offer => offer === offer_id)) {
            return provider;
          }
        }
      }
    }
    return false;
  }

  static convertArrayToObject(arr, property) {
    const obj = arr.reduce((acc, cur, i) => {
      if (property) acc[cur[property]] = cur;
      else acc[i] = cur;
      return acc;
    }, {});
    return obj;
  }

  static filterPaywayData(payway) {
    const filter = _.find(
      payway,
      v =>
        v.waspurchase === 1 &&
        v.purchase_data !== '' &&
        v.purchase_data !== null &&
        !_.isEmpty(v.purchase_data) &&
        v.purchase_data.gateway === 'plazavipgate',
    );
    return filter || null;
  }

  static buildQueryStringParams(object) {
    if (typeof object === 'object') {
      return Object.keys(object)
        .reduce((queryParams, k) => {
          if (object[k] !== undefined && object[k] !== null) {
            queryParams.push(`${k}=${object[k]}`);
          }
          return queryParams;
        }, [])
        .join('&');
    }
    return '';
  }

  static deviceCanPlay(provider, config = defaultProductEncodesConfiguration) {
    const { encodes } = config.subscrition[provider] || { encodes: [] };

    if (!encodes || !encodes.length) return true;

    const posibles = SUPPORTED_STREAM[this.getDeviceOS()] || [];

    return posibles.some(p => encodes.indexOf(p) > -1);
  }

  static isDeepLink(site) {
    if (site && site.includes('&') && site.includes('popGId')) {
      return true;
    }
  }

  static createDeepLinkToPlayer(site) {
    if (site.href && site.href.includes('&playerHtml5')) {
      const deepLink = new URL(site);
      const userId = getUserId();
      const groupId = deepLink.searchParams.get('group_id');
      const isLive =
        site.href.includes('&isLive') || site.href.includes('&islive');
      const showPlayer = site.href.includes('&showPlayer');
      let url = '';
      if (showPlayer && groupId && isLive) {
        url = ClaroUrlBuilder.player(groupId);
      } else {
        if (!site.origin) {
          site.origin = `${site.protocol}//${site.hostname}${
            site.port ? `:${site.port}` : ''
          }`;
        }
        const player = site.search.split('=');
        url = `${site.origin}/${player[player.length - 1]}${site.pathname}${
          site.search
        }`;
      }
      return url;
    }
    return site.href;
  }

  static rmSpecialCharacters(string) {
    return string.replace(/[^a-zA-Z0-9]/g, '');
  }

  static thereAtLeastOneElement(carrousels) {
    const carrouselsKeys = Object.keys(carrousels);
    return carrouselsKeys.some(ckey => carrousels[ckey].groups.length > 0);
  }

  static getPathFox(data) {
    let childs = [];
    let path = '';
    data.map(a => {
      if (a.code === 'playandgo') childs = a;
    });
    const node = this.buildFoxesNodes(childs);
    node.playandgo.carosuel.map(d => {
      if (d.code.includes('fox')) path = d.code;
    });
    return path;
  }

  static createUrlSearch(value, type) {
    const isLive = value?.live_enabled || value?.liveType
    ? Number(value?.live_enabled || value?.liveType)
    : 0;
    const node = 'home';  
    const region = localStorage.getItem('loginInfo.region');
    const experiencia = isNewExperienceEnabledWNTranslations(GetRegion())
      ? '&guidechannel'
      : '';

    const ambiente = `/${region}${PLAYER_SEGMENT}`;
    let url = '';
    const userId = getUserId();
    // TODO: Estas constantes no deberían de estár aquí.
    // Las mismas se usan en /dla-web/src/react/containers/PredictiveSearch/constants.js
    switch (isLive) {
      case 0:
        if (
          type.indexOf('_MOVIE') !== -1 ||
          type.indexOf('_SERIE') !== -1 ||
          type === 'SUGGEST'
        ) {
          url = `/${region}/vcard/${node}/${kebabCase(
            deburr(value.title_uri),
          )}/${value.id}`;
        } else {
          switch (type) {
            case 'TALENTS':
              const talentName = generateValueFor(value, [
                'name',
                'first_name',
                'last_name',
              ]);
              const provider = get(value, 'provider');
              const talentID = get(value, 'id');
              url = `/${region}/search?id=${talentID}&type=talent&q=${encodeURIComponent(
                talentName,
              )}&provider=${provider}`;
              break;
            case 'USERS_USER':
              url = `/${region}/socialProfile/${value.id}`;
              break;

            case 'EPG_EPGS_NOW': {
              const groupId = value.group_id ? value.group_id : value.id;
              url = `${ambiente}${groupId}`;
              break;
            }
            case 'EPG_EPGS_PAST':
            case 'EPG_EPGS_FUTURE':
              const startTime = new Date(value.begintime).getTime();
              url = `/${region}/event/${value.id}?groupId=${
                value.group_id
              }&startTime=${startTime}/`;
              break;

            case 'GENRES_GENRE':
              url = `/${region}/search?type=genre&q=${encodeURIComponent(
                value.name,
              )}`;
              break;
            default:
              url = '';
              break;
          }
        }
        break;
      case 1:
        const groupId = value.group_id ? value.group_id : value.id;
        url = `${ambiente}${groupId}`; //
        break;
      default:
        url = '';
        break;
    }
    return { url, isLive };
  }

  static createTelmexEmail(ip) {
    return `${ip}_${this.generateRandomToString(4)}@cv.com`;
  }
}

export function findGetParameter(parameterName) {
  let result = null;
  let tmp = [];
  window.location.search
    .substr(1)
    .split('&')
    .forEach(item => {
      tmp = item.split('=');
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  return result;
}

export function defineError(errorResponse, type = null) {
  if (type === errorResponse.errors.code) {
    return errorResponse.errors.code;
  }

  if (_.isArray(errorResponse.errors.error)) {
    return errorResponse.errors.error[0];
  }
  return errorResponse.errors.error || 'error inesperado';
}

export const replaceUserInformation = (msg, userData) => {
  const replacer = (str, p1, p2, p3, offset, s) =>
    userData[p2] || userData[p2.toLowerCase()];
  return msg.replace(/({@)([a-z]*)(})/gi, replacer);
};

export const isValidUrl = string => {
  try {
    new URL(string);
    return true;
  } catch (e) {
    return false;
  }
};

export const transformFooterUrl = (link, skin, lang, externalUrl) => {
  const { url } = link;

  switch (link.name) {
    case 'footer_link_terminos_condiciones':
      return '/terminos_y_condiciones';
    case 'footer_link_politicas_privacidad':
      return '/politicas_de_privacidad';
    case 'footer_link_tutoriales_video':
      return '/tutoriales_en_video';
    case 'footer_link_tutoriales':
      return '/tutoriales';
    case 'footer_link_preguntas_frecuentes':
      return '/faqs';
    case 'footer_link_licencia_usuario':
      return '/licencia_usuario_final';
    case 'footer_link_requerimientos':
      return '/requerimientos_minimos';
    case 'footer_link_terminos_promociones':
      return '/terminos_promociones';
    default:
      if (url && url.indexOf('fe') === 1 && !isValidUrl(url)) {
        return `/fe/sitesplus/${skin}/html/${lang}/${url}`;
      }
      return externalUrl;
  }
};

/**
 *
 * @param {strin} key nombre de la llave
 * @param {obj} translations objeto translations del state meta
 * @param {string} replaceText texto a sustituir en la llave
 * @param {string} newText texto nuevo
 */
export const keyReplaceText = (
  key,
  translations,
  replaceText,
  newText = '',
) => {
  const keyText = getTranslation(key, translations);

  const newTextKey = keyText.replace(replaceText, newText);
  return newTextKey;
};

/**
 *
 * @param {strin} key nombre de la llave
 * @param {obj} translations objeto translations del state meta
 * @param {array: [{text, newText}]} replaceText array de objetos, el objeto debe tener la propiedad text (el texto a sustituit) y newText (el nuevo texto)
 */
export const keyReplaceMultText = (key, translations, replaceText = []) => {
  const keyText = getTranslation(key, translations);

  const newFormattKey = replaceText?.reduce((accumulator, item) => {
    return accumulator?.replaceAll(item?.text, item?.newText);
  }, keyText);

  return newFormattKey;
};

export default Utils;

export const isNodeMyContent = codeMenu => {
  try {
    const nameNodeRegExp = new RegExp(CODE_MENU?.CONTENIDO, 'i');
    const isMyContent = codeMenu?.search(nameNodeRegExp) > -1;
    return isMyContent;
  } catch (error) {
    console.error(error);
  }
};

export const windowUtilsGetMetaMetadata = (metadata, returnDefault) => {
  try {
    return window.utils.getMeta.metadata(metadata);
  } catch (error) {
    console.warn(`Error ===> window.utils.getMeta.metadata(metadata)`, error);
    if (returnDefault === undefined) {
      return {};
    }
    return returnDefault;
  }
};
